<script lang="ts">
  import { Disclosure, DisclosureButton, DisclosurePanel } from '@rgossiaux/svelte-headlessui';
  import type { SupportedAs } from '@rgossiaux/svelte-headlessui/internal/elements';
  import { createEventDispatcher } from 'svelte';
  import { slide } from 'svelte/transition';

  export let open = false;
  let priorState = open;
  let as: SupportedAs | undefined;

  let clazz = '';
  export { clazz as class };
  export let titleClass: string = '';
  export let contentClass: string = '';

  interface $$Events {
    open: CustomEvent<null>;
    close: CustomEvent<null>;
  }

  interface $$Props {
    as?: SupportedAs;
    open?: boolean | undefined;
    class?: string;
    titleClass?: string;
    contentClass?: string;
  }

  const dispatch = createEventDispatcher<$$Events>();

  $: {
    if (priorState !== open) {
      priorState = open;
      dispatch(open ? 'open' : 'close');
    }
  }
</script>

<Disclosure class={clazz}>
  <DisclosureButton class={titleClass} {as} on:click={() => (open = !open)}
    ><slot name="title" /></DisclosureButton
  >
  {#if open}
    <div transition:slide|local>
      <DisclosurePanel class={contentClass} static><slot name="content" /></DisclosurePanel>
    </div>
  {/if}
</Disclosure>
